export const siteInfo = {
  name: '大桥未久官方专区',
  url: 'https://ohashi-miku-fans.com',
  description: '大桥未久专属页面，汇聚大桥未久全系列作品、出道历程、最新动态及粉丝必看内容。深度解析大桥未久的演艺风格与代表作，为资深爱好者提供最全面、最权威的一站式资讯平台。',
  keywords: '大桥未久,大桥未久作品全集,大桥未久最新作品,大桥未久代表作,大桥未久写真,大桥未久粉丝资讯',
  brandIntro: '大桥未久官方专区是专注于日本知名艺人大桥未久的综合性粉丝资讯平台。我们致力于为全球华人粉丝提供最全面、最新鲜、最权威的大桥未久相关内容，涵盖作品全集、最新动态、演艺历程、精美写真以及粉丝互动等多元化信息服务。自平台创立以来，坚持以高品质内容和精准资讯服务广大爱好者，已成为华语圈最具影响力的大桥未久粉丝社区之一。',
  reputation: '我们以严谨的态度和专业的精神，获得了广大粉丝的一致认可与信赖。平台内容更新及时、信息准确全面，粉丝社区活跃友好。我们与多家日本娱乐媒体保持良好合作关系，确保资讯的时效性和权威性。每一篇内容都经过精心策划与编撰，力求为粉丝呈现最优质的大桥未久资讯体验。',
  contact: {
    email: 'contact@ohashi-miku-fans.com',
    weibo: '@大桥未久官方专区',
    wechat: 'OhashiMiku_Official',
  },
};